<mat-spinner color="secondary" *ngIf="!pageData"></mat-spinner>

<!-- content -->
<section *ngIf="pageData">
  <div>
    <h1>
      {{ pageData.title }}
    </h1>

    <div class="callout" *ngIf="pageData && pageData.title !== 'Gallery'">
      <h3>Have your own submissions?</h3>

      <div class="fx-layout-column--xs">
        <div class="fx-flex--100--xs">
          Enter your best submissions now.  You could win <strong>up to $300</strong>! Enter now for more information.
        </div>
        <div class="fx-flex--100--xs">
          <a mat-flat-button color="primary" routerLink="/matboard-awards">
            Enter Now
            <mat-icon svgIcon="chevron-right"></mat-icon>
          </a>
        </div>
      </div>
    </div>

    <mbnm-navigation-tiles *ngIf="pageData.images && pageData.images.length > 0" [tileCollection]="pageData.images" mode="image" (tileClick)="  ($event)">

    </mbnm-navigation-tiles>

    @for (galleryData of pageData.children; track galleryData) {
      <h2 *ngIf="pageData.children.length > 1">{{ galleryData.title }}</h2>
      <mbnm-navigation-tiles [tileCollection]="galleryData.images" mode="image">

      </mbnm-navigation-tiles>
    }
  </div>
</section>
